module.exports = __webpack_public_path__ + "static/media/tuberia-conduit-codo-pared-gruesa.ff96dcc8.jpg";